import React from 'react';
import { Trans } from 'react-i18next';
import { SubpageHero } from '../../../../components/web/subpage-hero/subpage-hero';

export const IntroCompoundInterest: React.FC = () => {
    return (
        <SubpageHero
            visual="calculator"
            title={<Trans i18nKey="pages.compoundInterest.hero.title" components={{ span: <span /> }} />}
            description={<Trans i18nKey="pages.compoundInterest.hero.subtitle" components={{ strong: <strong /> }} />}
        />
    );
};
